import type { InternalCompareFlagsAcrossEnvironmentsOpenAPIQueryParams } from '../generated/operations/raw-openapi-query-params-for-serializers';

export type InternalCompareFlagsAcrossEnvironmentsQueryParams =
  InternalCompareFlagsAcrossEnvironmentsOpenAPIQueryParams;

export function querySerializer(queryParams: InternalCompareFlagsAcrossEnvironmentsQueryParams) {
  const searchParams = new URLSearchParams();

  // Required params
  searchParams.set('sourceEnv', queryParams.sourceEnv);
  searchParams.set('targetEnv', queryParams.targetEnv);

  // Optional params
  if (queryParams.sort) {
    searchParams.set('sort', queryParams.sort);
  }

  if (queryParams.filter) {
    searchParams.set('filter', queryParams.filter);
  }

  if (queryParams.limit !== undefined) {
    searchParams.set('limit', queryParams.limit.toString());
  }

  if (queryParams.offset !== undefined) {
    searchParams.set('offset', queryParams.offset.toString());
  }

  return searchParams.toString();
}
